module.exports = "/_next/static/images/check-a677fb3d3f1ce669b6dc844669bbfc8b.svg";